import {axiosRequest} from "../../api";
import {API_PATH} from "../../../constants";

export const ExaminationService = {
  getExaminationList(params: any){ return axiosRequest('GET', API_PATH.EXAMINATION.LIST(params)) },
  getExamination(data: any){ return axiosRequest('POST', API_PATH.EXAMINATION.INFO, data) },
  lastExaminationDetail(data: any){ return axiosRequest('POST', API_PATH.EXAMINATION.LAST, data) },
  ECGLead(data: any){ return axiosRequest('POST', API_PATH.EXAMINATION.LEADS, data) },
  ECGSegment(data: any){ return axiosRequest('POST', API_PATH.EXAMINATION.SEGMENT, data) },
}